import { ProfileState } from './state';
/* import { normalize } from 'normalizr';
import * as schema from '../../../utils/schema'; */

import * as   types from './types';

export default function profile(state =  ProfileState, action: any) {

  switch (action.type) {
    case types.PROFILE_GET:
      return {
        ...state,
        ...action.payload
      }

    default:
      return state;
  }
}
